import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEY = "sirija.admin.token.v1";

export function getToken() {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
}
export function setToken(t) {
  try {
    if (t) window.localStorage.setItem(KEY, t);
    else window.localStorage.removeItem(KEY);
  } catch {}
}

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${t}` };
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) setToken(null);
    return Promise.reject(err);
  }
);

export async function login(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data;
}

export function logout() { setToken(null); }
